class ServiceWorker {
  get supportedLanguages() {
    // If modifying language list, do bump cacheVersion in /sw.js
    return window.availableLanguages || ['de', 'en'];
  }

  init() {
    if (!navigator.serviceWorker) {
      return;
    }

    const productionDomains = ['www.data4life.care', 'www.data4life-asia.care'];
    const isProduction = productionDomains.indexOf(document.location.host) !== -1;
    const isServiceWorkerEnabled = true; // feature flag and kill switch for service workers
    let hasLocalStorageSupport = false;
    try {
      localStorage.getItem('content_diff');
      hasLocalStorageSupport = true;
    } catch (_) {}

    if (isServiceWorkerEnabled && isProduction && 'BroadcastChannel' in self && hasLocalStorageSupport) {
      this.register();
      this.connect();
    } else {
      this.unregister();
    }
  }

  register() {
    window.navigator.serviceWorker.register('/' + 'sw.js');
  }

  unregister() {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  }

  connect() {
    const multilingualDomains = ['www.data4life.care'];
    const isMultilingual = multilingualDomains.indexOf(document.location.host) !== -1;

    const broadcast = new BroadcastChannel('cache-channel');
    broadcast.onmessage = this.onMessage.bind(this);

    new Promise((resolve) => this.awaitServiceWorkerController(resolve)).then((controller) => {
      controller.postMessage({
        connected: true,
        deps: this.getDeps(),
        supportedLanguages: this.supportedLanguages,
        cacheHomeRedirection: isMultilingual,
      });
      broadcast.postMessage('fetch-inbox');
    });
  }

  awaitServiceWorkerController(resolve) {
    if (!navigator.serviceWorker.controller) {
      return setTimeout(() => this.awaitServiceWorkerController(resolve), 1);
    }

    resolve(navigator.serviceWorker.controller);
  }

  onMessage({ data = {} }) {
    if (data === 'fetch-inbox') {
      return;
    }

    if (data.isDocumentDiff) {
      return this.onDocumentDiff(data);
    }

    console.error(
      'Unhandled message from sw. Run window.debugSwMessage() to see the data. Keys: ' +
        JSON.stringify(Object.keys(data))
    );
    window.debugSwMessage = () => console.log(data);
  }

  onDocumentDiff({ url }) {
    if (url !== document.location.href) {
      return;
    }

    if (localStorage.getItem('content_diff') === url) {
      localStorage.removeItem('content_diff');
      return;
    }

    localStorage.setItem('content_diff', url);
    document.location.reload();
  }

  getDeps() {
    const html = document.head.innerHTML + document.body.innerHTML;
    return this._getOfflineUrls()
      .concat(['/favicon.ico', document.location.href])
      .concat(
        html
          .match(/["'(](http|\/)[^"'()]+\.[^"'()./]+["')]/g)
          .map((url) => url.replace(/["'()]/g, ''))
          .filter((url, index, group) => group.indexOf(url) === index)
          .filter((url) => url.includes(document.location.origin) || url.indexOf('/') === 0)
      );
  }

  _getOfflineUrls() {
    return this.supportedLanguages.map((language) => `/${language}/offline/`);
  }
}

export default new ServiceWorker();
